import { createAction, props } from "@ngrx/store";
import { Inventory, InventoryResponse, Requirement, AvailableRoomCount } from "@estatex/types";


const initInventory = createAction("[Inventory Page] Init");

const loadInventorySuccess = createAction("[Inventory/API] Load Inventory Success", props<{ inventory: Inventory[] }>());

const loadInventoryFailure = createAction("[Inventory/API] Load Inventory Failure", props<{ error: any }>());

const saveRequirement = createAction("[Inventory/Store] Save Requirement", props<{ requirement: Requirement }>());

const saveInventory = createAction("[Inventory/Store] Save Inventory", props<{ inventory: InventoryResponse }>());

const setAvailableRooms = createAction("[Inventory/Store] Set Available Rooms", props<{ availableRooms: AvailableRoomCount }>());

export const InventoryActions = {
    initInventory,
    loadInventorySuccess,
    loadInventoryFailure,
    saveRequirement,
    saveInventory,
    setAvailableRooms,
};
